// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o8fO","left":"styles_left__3GRI_"};